// @mui
import { Box, Breadcrumbs, Stack } from '@mui/material';
import { useMemo } from 'react';
import { Iconify } from 'src/components/iconify';
import { BreadcrumbsItem } from './BreadcrumbsItem';
import { BreadcrumbsItemProps, CustomBreadcrumbsProps } from './types';

export default function DriveMoveBreadcrumbs({
  action,
  sx,
  ancestors,
  ...other
}: CustomBreadcrumbsProps) {
  const itens = useMemo(() => {
    const defalutItens: BreadcrumbsItemProps[] = [
      {
        icon: <Iconify icon="tabler:cloud" />,
        name: 'Drive',
        id: '',
      },
    ];

    if (!ancestors) return defalutItens;

    const folders = ancestors.ancestors
      .sort((a, b) => a.level - b.level)
      .map<BreadcrumbsItemProps>((content) => ({
        name: content.name,
        id: content._id,
      }));

    return defalutItens.concat(...folders, { name: ancestors.name });
  }, [ancestors]);

  return (
    <Box sx={{ ...sx }}>
      <Stack direction="row" alignItems="center">
        <Box alignItems="center" sx={{ flexGrow: 1, display: 'flex' }}>
          {!!itens?.length && (
            <Breadcrumbs
              separator={<Separator />}
              {...other}
              sx={{ typography: 'body2' }}
            >
              {itens.map((item) => (
                <BreadcrumbsItem
                  key={item.name || ''}
                  item={item}
                  action={action}
                />
              ))}
            </Breadcrumbs>
          )}
        </Box>
      </Stack>
    </Box>
  );
}

const Separator = () => {
  return (
    <Box component="span" sx={{ fontSize: '15px' }}>
      /
    </Box>
  );
};
